// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"840":"1e566dfe","963":"120cdc9e"}[chunkId] + ".chunk.js";
};